import React, { FC } from 'react';
import { PaxModel } from '../ts/PaxModel';

interface BookDetailsProps {
  pax: PaxModel;
  price: string;
}

const BookDetails: FC<BookDetailsProps> = ({ pax, price }) => {
  return (
    <div className="row">
      <div className="col-12">
        <div className="book-item">
          <span>שם פרטי</span>
          <span className="line"></span>
          <span>{pax.firstName}</span>
        </div>
      </div>
      <div className="col-12">
        <div className="book-item">
          <span>שם משפחה</span>
          <span className="line"></span>
          <span>{pax.lastName}</span>
        </div>
      </div>
      <div className="col-12">
        <div className="book-item">
          <span>טלפון</span>
          <span className="line"></span>
          <span>{pax.phone}</span>
        </div>
      </div>
      <div className="col-12">
        <div className="book-item">
          <span>דוא"ל</span>
          <span className="line"></span>
          <span>{pax.email}</span>
        </div>
      </div>
      <div className="col-12">
        <div className="book-item">
          <span>מספר נוסעים</span>
          <span className="line"></span>
          <span>{pax.passengersCount}</span>
        </div>
      </div>
      <div className="col-12">
        <div className="book-item">
          <span>מחיר סה"כ</span>
          <span className="line"></span>
          <span>{price}</span>
        </div>
      </div>
    </div>
  );
};

export default BookDetails;
